module.exports = __webpack_public_path__ + "static/media/Alsina Ultrajada.38635a91.TTF";